<template>
  <div>
    <vs-sidebar
      position-right
      parent="body"
      default-index="1"
      class="sidebarx"
      v-model="active"
    >
      <div class="content">
        <section class="section--sidebar-user">
          <section class="section--title-sidebar">
            <h3>All charts</h3>
          </section>
          <section
            class="
              section--content-sidebar section--content-sidebar-full-height
            "
          >
            <form
              id="add_all_charts"
              method="POST"
              :action="this.action"
              accept-charset="UTF-8"
              enctype="multipart/form-data"
            >
              <input type="hidden" name="_token" :value="csrf" />
              <div id="recapRoles">
                <div class="form-group">
                  <small
                    >The session will be mounted with this configuration</small
                  >
                </div>
                <div class="form-group">
                  <div class="single--item">
                    <div class="single--item-info">
                      <h6>Role</h6>
                    </div>
                    <div class="single--item-info">
                      <h6>Function name</h6>
                    </div>
                    <div class="single--item-info">
                      <h6>Subsequent</h6>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="single--item" v-for="row in parameters">
                    <div class="single--item-info">
                      <h6>{{ row.role }}</h6>
                    </div>
                    <div class="single--item-info">
                      <h6>{{ row.function_name }}</h6>
                    </div>
                    <div class="single--item-info">
                      <h6>{{ row.subsequent }}</h6>
                    </div>
                  </div>
                </div>
              </div>

              <div id="error_addAll">
                <div class="form-group">
                  <small
                    >The session will be mounted with this configuration</small
                  >
                </div>
                <div class="form-group">
                  <div class="single--item">
                    <div class="single--item-info">
                      <h6>Person</h6>
                    </div>
                    <div class="single--item-info">
                      <h6>Role</h6>
                    </div>
                    <div class="single--item-info">
                      <h6>Error</h6>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="single--item" v-for="row in errorLog">
                    <div class="single--item-info">
                      <h6>{{ row.person }}</h6>
                    </div>
                    <div class="single--item-info">
                      <h6>{{ row.role }}</h6>
                    </div>
                    <div class="single--item-info single--item-info-danger">
                      <h6>{{ row.error }}</h6>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="can_write" class="form-buttons clear">
                <i
                  id="spinner"
                  style="display: none"
                  class="fas fa-spinner fa-pulse"
                ></i>
                <div>
                  <button
                    id="addAllButton"
                    type="button"
                    @click="addAllChart"
                    class="btn btn--green"
                  >
                    {{ __("misc.add_all") }}
                  </button>
                </div>
              </div>
            </form>
          </section>
        </section>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: null,
      editing: false,
      active: false,
      action: "",
      itemId: -1,
      title: "",
      parameters: {},
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
      selectedPerson: {},
      selectedRole: {},
      errorLog: {},
    };
  },
  methods: {
    addAllChart() {
      let form = $("form#add_all_charts");

      let post = {};
      let data = form.serializeArray();
      $(data).each(function () {
        post[this.name] = this.value;
      });

      $("#addAllButton").prop("disabled", true);
      $("#spinner").show();
      axios
        .post(form.attr("action"), post)
        .then((response) => {
          $("#spinner").hide();
          this.errorLog = response.data.errorLog;
        })
        .catch(function (error) {
          alert(error);
          console.log(error);
        });
    },

    toggle(action, item_id, editing, attributes) {
      console.log(action, item_id, editing, attributes);
      this.active = true;
      this.action = action;
      this.editing = editing;
      this.itemId = item_id;
      this.title = attributes.title;
      let url = attributes.url;
      if (url !== undefined) {
        if (url.indexOf("[id]") > 0) {
          url = url.replace("[id]", item_id);
        }
        axios.get(url).then((response) => {
          this.parameters = response.data;
          //$("#spinnerWait").css('display',"none");
        });
      }
    },
  },
  mounted() {},
  props: {
    can_write: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
